import styled from 'styled-components';
import { InputBase, withStyles, IconButton, Tooltip } from '@material-ui/core';
import { colours as colors } from '@cambridgeassessment/cambridge-ui';

export const StyledInputContainer = styled.div<{ focus?: boolean }>`
  position: relative;
  display: flex;
  width: 352px;
  height: 44px;
  border-radius: 6px;
  border: solid 1px ${(props): string => (props.focus === true ? colors.scienceBlue : '#b8c0cc')};
  background-color: #fdfdfd;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: #12151a;
`;

export const StyledIconContainer = styled.div<{ focus?: boolean }>`
  padding: 8px;
  height: 100%;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props): string => (props.focus === true ? colors.scienceBlue : 'inherit')};
`;

export const StyledInputBase = withStyles({
  root: {
    color: 'inherit',
    width: '100%',
    fontSize: 'inherit',
  },
  input: {
    '&::placeholder': {
      color: '#5c6066',
      opacity: 1,
    },
  },
})(InputBase);

export const StyledIconButton = withStyles({
  root: {
    color: colors.black,
    '&:hover': {
      backgroundColor: 'transparent',
      color: colors.black,
    },
  },
})(IconButton);

export const StyledTooltip = withStyles({
  popper: {
    marginTop: '-10px',
  },
  arrow: {
    color: colors.black,
  },
  tooltip: {
    backgroundColor: colors.black,
    fontSize: '14px',
  },
})(Tooltip);
